import { css, keyframes } from 'styled-components';
import constants from './constants';

export const media: any = Object.keys(constants.screens).reduce(
  (acc, label) => {
    return {
      ...acc,
      [label]: (literals: TemplateStringsArray, ...args: any[]) => css`
        @media (min-width: ${constants.screens[
            label as 'phone' | 'tablet' | 'medium' | 'desktop'
          ].size}px) {
          ${css(literals, ...args)}
        }
      `,
    };
  },
  {},
);

export const rotate = keyframes`
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    transform-origin: center center;
  }

  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
    transform-origin: center center;
  }
`;

export const appearIn = keyframes`
  from { opacity: 0; }

  to { opacity: 1; }
`;

export const appearOut = keyframes`
  from { opacity: 1; }

  to { opacity: 0; }
`;
